import firebase from 'firebase/app'
import 'firebase/auth'

const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}')

const app = firebase.initializeApp(config)

export default app
